module.exports = __webpack_public_path__ + "static/img/right5.9e3048bc.png";